import React from 'react';

import type { UnionsMenuLayerItem } from '../../types';

import { UnionsMenuItems } from './UnionsMenuItems';

import styles from './UnionsMenu.module.scss';

type UnionsMenuItemsProps = {
  list: UnionsMenuLayerItem[];
};

export const UnionsMenu: React.FC<UnionsMenuItemsProps> = ({ list }) => {
  return (
    <ul className={styles.list}>
      <UnionsMenuItems list={list} />
    </ul>
  );
};
